import Model from '@/store/plugins/orm/Model'
import HashGen from '@/utilities/HashGen';
import Money from '@/wrappers/Money';
import i18n from '@/i18n';
import { Product } from './ModelRepository';

export class WriteOffItem extends Model {
    static get entity () {
        return 'write_off_items'
    }

    static fields () {
        return {
            id: this.attr(null),
            write_off_id: this.attr(null),
            date: this.attr(null),
            product_id: this.attr(null),
            unit_of_measure: this.attr(null),
            tax_rate: this.attr('0.00', value => _.round(value, 2).toFixed(2)),
            quantity: this.attr('1.000', value => _.round(value, 3).toFixed(3)),
            selling_price: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            selling_price_after_tax: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            recorded_at: this.attr(null),

            hash: this.attr(HashGen.regular()),
        }
    }

    getTaxRate() {
        return parseFloat(this.tax_rate);
    }

    getQuantity() {
        return parseFloat(this.quantity);
    }

    getSellingPrice() {
        return Money.parse(this.selling_price);
    }

    getSellingPriceAfterTax() {
        return Money.parse(this.selling_price_after_tax);
    }

    getSellingValue() {
        const value = this.getSellingPrice()
            .multiply(this.getQuantity())

        return Money.parse(value.toFormat('0.0000'));
    }

    getTax() {
        const value = this.getSellingValue()
            .multiply(this.getTaxRate() / 100);

        return Money.parse(value.toFormat('0.0000'));
    }

    getSellingValueAfterTax() {
        const value = this.getSellingValue()
            .add(this.getTax());

        return Money.parse(value.toFormat('0.0000'));
    }

    getProduct() {
        return Product.all().find(product => product.id === this.product_id);
    }

    getUnitOfMeasure() {
        return i18n.t(`products.unit_of_measure.${this.unit_of_measure}`) !== `products.unit_of_measure.${this.unit_of_measure}`
            ? i18n.t(`products.unit_of_measure.${this.unit_of_measure}`)
            : this.unit_of_measure
    }
}

export default WriteOffItem
